import { render, staticRenderFns } from "./winnerLf.vue?vue&type=template&id=745beddc&scoped=true&"
import script from "./winnerLf.vue?vue&type=script&lang=js&"
export * from "./winnerLf.vue?vue&type=script&lang=js&"
import style0 from "./winnerLf.vue?vue&type=style&index=0&id=745beddc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745beddc",
  null
  
)

export default component.exports